interface PageParams {
    pathname: string;

    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'energy-solutions-for-business',

    sites: ['us'],
};

export const pathname = pageParams.pathname;
export const sites = pageParams.sites;
